import { ESdkEvents, EventParams } from './contracts';
import { InternalMessageEventsName } from './constants/enums';

const sendFEEvent = (eventName: ESdkEvents, params: Partial<EventParams>) => {
  const sessionId = location.pathname.slice(1);
  const eventData = {
    event: eventName,
    params: { ...params, sessionId },
  };
  window.parent.postMessage(eventData, '*');
};

const sendInternalFEEvent = (
  customWindow: Window | null,
  eventName: InternalMessageEventsName,
  params: any = {},
) => {
  const eventData = {
    event: eventName,
    params,
  };
  customWindow?.postMessage(eventData);
};

export { sendFEEvent, sendInternalFEEvent };
